import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SetPasswordComponent } from './set-password.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';

@NgModule({
    declarations: [
        SetPasswordComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule
    ],
    providers: []
})
export class SetPasswordModule {
}
